import Change from '../changes/change.entity';
import CmStorageLocation from '../cm-storage-locations/cm-storage-location.entity';
import CmWrapBox from '../cm-wrap-boxes/cm-wrap-box.entity';
import { DEPARTMENTS } from '../enums/enums';
import PrWrapBox from '../pr-wrap-boxes/pr-wrap-box.entity';
import PropStorageLocation from '../prop-storage-locations/prop-storage-location.entity';
import SetStorageLocation from '../set-storage-locations/set-storage-location.entity';
import SetWrapBox from '../set-wrap-boxes/set-wrap-box.entity';
import {
	SosCreateResponse,
	SosGetResponse,
	SosListResponse,
} from '../sos-response';
import { BaseESDoc, InventoryDepartment } from '../types';
import Picture from '../pictures/picture.entity';

export interface WrapBoxESDoc extends BaseESDoc {
	name: string;
}

export type CmWrapBoxESDoc = WrapBoxESDoc;
export type PrWrapBoxESDoc = WrapBoxESDoc;
export type SetWrapBoxESDoc = WrapBoxESDoc;

export interface WrapBoxListResponse extends SosListResponse {
	listed: {
		CmWrapBox: CmWrapBox[];
		PrWrapBox: PrWrapBox[];
		SetWrapBox: SetWrapBox[];
	};
}

export interface DeptSpecificWrapBoxCreateResponse<
	T extends InventoryDepartment
> extends SosCreateResponse {
	created: T extends DEPARTMENTS.CM
		? {
				CmWrapBox: CmWrapBox[];
		  }
		: T extends DEPARTMENTS.PR
		? {
				PrWrapBox: PrWrapBox[];
		  }
		: T extends DEPARTMENTS.SET
		? {
				SetWrapBox: SetWrapBox[];
		  }
		: never;
}

export type WrapBoxCreateResponse = DeptSpecificWrapBoxCreateResponse<
	InventoryDepartment
>;

export interface DeptSpecificWrapBoxGetResponse<T extends InventoryDepartment>
	extends SosGetResponse {
	listed: T extends DEPARTMENTS.CM
		? {
				CmWrapBox: CmWrapBox[];
				Change?: Change[];
				CmStorageLocation?: CmStorageLocation[];
				Picture: Picture[];
		  }
		: T extends DEPARTMENTS.PR
		? {
				PrWrapBox: PrWrapBox[];
				PrStorageLocation: PropStorageLocation[];
				Picture: Picture[];
		  }
		: T extends DEPARTMENTS.SET
		? {
				SetWrapBox: SetWrapBox[];
				SetStorageLocation: SetStorageLocation[];
				Picture: Picture[];
		  }
		: never;
}

export type WrapBoxGetResponse = DeptSpecificWrapBoxGetResponse<
	InventoryDepartment
>;
